(() => {
  const init = () => {
    // Keep native policy wording while removing imported editor wrappers and duplicate titles.
    document.querySelectorAll('[data-kw-policy-body], .shopify-policy__body').forEach(policy => {
      if (policy.dataset.cleaned) return;
      policy.dataset.cleaned = 'true';
      const importedCopy = policy.querySelector('[data-message-author-role="assistant"] .markdown');
      if (importedCopy) policy.replaceChildren(...Array.from(importedCopy.childNodes));
      const outerTitle = policy.closest('.shopify-policy__container')?.querySelector('.shopify-policy__title h1');
      if (outerTitle) {
        policy.querySelector('h1')?.remove();
        policy.querySelectorAll('h1').forEach(heading => {
          const replacement = document.createElement('h2'); replacement.innerHTML = heading.innerHTML; heading.replaceWith(replacement);
        });
      }
      policy.querySelectorAll('a[href]').forEach(link => {
        try {
          const url = new URL(link.href);
          if (url.searchParams.get('utm_source') === 'chatgpt.com') { url.searchParams.delete('utm_source'); link.href = url.href; }
        } catch {}
      });
    });
    const strings = document.getElementById('kw-pages-strings')?.dataset || {};
    const reviewBar = document.getElementById('kw-rv-filter');
    const reviewWall = document.getElementById('reviews-wall');
    if (reviewBar && reviewWall && !reviewBar.dataset.bound) {
      reviewBar.dataset.bound = 'true';
      const fold = () => requestAnimationFrame(() => reviewWall.querySelectorAll('.rv').forEach(review => {
        const quote = review.querySelector('.rv-q');
        const more = review.querySelector('.rv-more');
        if (!quote || !more || review.classList.contains('rv-open')) return;
        more.hidden = quote.scrollHeight <= quote.clientHeight + 2;
        more.setAttribute('aria-expanded', 'false');
      }));
      reviewWall.addEventListener('click', event => {
        const button = event.target.closest('.rv-more');
        if (!button) return;
        const open = button.closest('.rv').classList.toggle('rv-open');
        button.textContent = open ? strings.less : strings.more;
        button.setAttribute('aria-expanded', String(open));
      });
      reviewBar.addEventListener('click', event => {
        const button = event.target.closest('button[data-rv]');
        if (!button) return;
        reviewBar.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        reviewWall.querySelectorAll('.rv').forEach(review => { review.hidden = button.dataset.rv !== 'all' && review.dataset.src !== button.dataset.rv; });
        fold();
      });
      addEventListener('resize', fold, { passive: true });
      fold();
    }
    document.querySelectorAll('.kw-form input[type="date"]').forEach(input => {
      const today = new Date();
      input.min = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
    });
    document.querySelectorAll('.kw-native-form-result').forEach(result => { if (!result.closest('#kw-inquiry-form') && result.querySelector('[role="alert"], [role="status"]')) result.focus(); });
    const form = document.getElementById('kw-inquiry-form');
    if (form && !form.dataset.bound) {
      form.dataset.bound = 'true';
      const parameters = new URLSearchParams(location.search);
      const byId = id => document.getElementById(id);
      const inquiryPage = document.getElementById('pg-inquire');
      if (inquiryPage) inquiryPage.dataset.inquiryLayout = 'portrait';
      const note = byId('iq-context-note');
      const submit = form.querySelector('button[type="submit"]');
      const requiredNote = form.querySelector('.kw-iqc-required-note');
      const defaultRequiredNote = requiredNote?.textContent || '';
      const result = form.querySelector('[data-inquiry-result]')?.dataset.inquiryResult;
      const contextKey = 'kw-watch-inquiry:' + location.pathname + ':' + (parameters.get('view') || '');
      const returnTo = form.querySelector('input[name="return_to"]');
      if (returnTo) {
        const returnURL = new URL(location.href);
        returnURL.searchParams.delete('contact_posted');
        returnURL.hash = 'kw-inquiry-form';
        returnTo.value = returnURL.pathname + returnURL.search + returnURL.hash;
      }
      let selectedContext = null;
      let productPath = parameters.get('product_url') || '';
      let handle = parameters.get('product') || '';
      let variantId = parameters.get('variant') || '';
      if (!handle && !productPath && (result || parameters.get('contact_posted') === 'true')) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(contextKey) || 'null');
          if (saved && Date.now() - saved.savedAt < 30 * 60 * 1000) {
            handle = saved.handle || '';
            variantId = saved.variantId || '';
          }
        } catch {}
      }
      const showUnavailable = () => {
        form.dataset.contextState = 'unavailable';
        note.textContent = note.dataset.unavailable;
        note.hidden = false;
        const manualWatch = byId('iq-watch');
        manualWatch.type = 'text';
        manualWatch.required = true;
        byId('iq-manual-watch').querySelector('.kw-optional')?.setAttribute('hidden', '');
        byId('iq-manual-watch').hidden = false;
        if (requiredNote) requiredNote.textContent = requiredNote.dataset.unavailable || defaultRequiredNote;
        submit.disabled = false;
      };
      form.addEventListener('submit', event => {
        if (form.dataset.contextState === 'loading') { event.preventDefault(); return; }
        try {
          if (selectedContext) sessionStorage.setItem(contextKey, JSON.stringify({ ...selectedContext, savedAt: Date.now() }));
          else sessionStorage.removeItem(contextKey);
        } catch {}
      });
      if (handle || productPath) {
        try {
          if (productPath) {
            const pathURL = new URL(productPath, location.origin);
            const pathHandle = /\/products\/([a-z0-9-]+)\/?$/i.exec(pathURL.pathname)?.[1] || '';
            if (pathURL.origin !== location.origin || !pathHandle || (handle && handle !== pathHandle)) throw new Error('Invalid product path');
            handle = pathHandle;
            variantId = variantId || pathURL.searchParams.get('variant') || '';
          }
          if (!/^[a-z0-9-]+$/i.test(handle) || (variantId && !/^\d+$/.test(variantId))) throw new Error('Invalid product context');
          const root = window.Shopify?.routes?.root || '/';
          const productURL = new URL(root + 'products/' + encodeURIComponent(handle), location.origin);
          if (productURL.origin !== location.origin) throw new Error('Invalid storefront root');
          if (variantId) productURL.searchParams.set('variant', variantId);
          const previewTheme = parameters.get('preview_theme_id');
          if (previewTheme && /^\d+$/.test(previewTheme)) productURL.searchParams.set('preview_theme_id', previewTheme);
          const ajaxURL = new URL(productURL);
          ajaxURL.pathname += '.js';
          form.dataset.contextState = 'loading';
          submit.disabled = true;
          note.textContent = note.dataset.loading;
          note.hidden = false;
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 8000);
          const fetchOptions = { credentials: 'same-origin', signal: controller.signal };
          Promise.all([
            fetch(ajaxURL, { ...fetchOptions, headers: { Accept: 'application/json' } }).then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); }),
            fetch(productURL, { ...fetchOptions, headers: { Accept: 'text/html' } }).then(response => response.ok ? response.text() : '').catch(() => '')
          ]).then(([product, html]) => {
            if (product.handle !== handle || !Array.isArray(product.variants) || !product.variants.length) throw new Error('Product unavailable');
            const variant = variantId ? product.variants.find(item => String(item.id) === variantId) : product.variants.find(item => item.available) || product.variants[0];
            if (!variant || !/^\d+$/.test(String(product.id)) || !/^\d+$/.test(String(variant.id))) throw new Error('Variant unavailable');
            const title = variant.title && variant.title !== 'Default Title' ? product.title + ' — ' + variant.title : product.title;
            const tags = Array.isArray(product.tags) ? product.tags.map(String) : [];
            const productDocument = new DOMParser().parseFromString(html, 'text/html');
            const source = productDocument.querySelector('[data-kw-product-reference]');
            if (inquiryPage && source?.getAttribute('data-kw-product-kind') === 'accessory') {
              inquiryPage.querySelectorAll('[data-inquiry-heading], [data-inquiry-intro]').forEach(element => {
                if (element.dataset.itemLabel) element.textContent = element.dataset.itemLabel;
              });
            }
            const description = new DOMParser().parseFromString(String(product.description || '').replace(/<\/(?:p|li|div|h[1-6])>|<br\s*\/?>/gi, '\n'), 'text/html').body.textContent || '';
            const taggedReference = tags.find(tag => /^reference:/i.test(tag))?.replace(/^reference:/i, '').trim();
            const describedReference = /(?:^|\n)\s*Reference:\s*([^\n]+)/i.exec(description)?.[1]?.trim() || /\bRef\.\s+([^\n<]+?)(?:\s+—|$)/i.exec(description)?.[1]?.trim();
            const reference = source?.getAttribute('data-kw-product-reference')?.trim() || taggedReference || describedReference || '';
            productURL.searchParams.set('variant', String(variant.id));
            byId('iq-watch').value = title;
            byId('iq-watch').type = 'hidden';
            byId('iq-watch').required = false;
            if (requiredNote) requiredNote.textContent = defaultRequiredNote;
            byId('iq-reference').value = String(reference);
            byId('iq-watch-id').value = String(product.id);
            byId('iq-variant-id').value = String(variant.id);
            byId('iq-sku').value = String(variant.sku || '');
            const canonicalLink = productDocument.querySelector('link[rel="canonical"]')?.getAttribute('href');
            let permanentProductURL = new URL(productURL);
            if (canonicalLink) {
              try {
                const canonical = new URL(canonicalLink, location.origin);
                if (canonical.protocol === 'https:' && canonical.pathname === productURL.pathname) permanentProductURL = canonical;
              } catch {}
            }
            permanentProductURL.search = '';
            permanentProductURL.searchParams.set('variant', String(variant.id));
            byId('iq-product-url').value = permanentProductURL.href;
            byId('iq-product-link').href = productURL.href;
            // Present the catalog title, removing only its repeated vendor; keep full context in contact[watch].
            const vendor = source?.getAttribute('data-kw-product-brand')?.trim() || String(product.vendor || '').trim();
            const productTitle = String(product.title || '');
            const yearPrefix = /^(?:19|20)\d{2}\s+/.exec(productTitle)?.[0] || '';
            const afterYear = productTitle.slice(yearPrefix.length);
            const repeatedVendor = vendor && afterYear.toLocaleLowerCase().startsWith(vendor.toLocaleLowerCase() + ' ');
            const displayTitle = repeatedVendor ? yearPrefix + afterYear.slice(vendor.length).trim() : productTitle;
            byId('iq-title').textContent = displayTitle;
            byId('iq-title').title = productTitle;
            const variantDisplay = byId('iq-variant-display');
            if (variantDisplay) {
              variantDisplay.textContent = variant.title !== 'Default Title' ? variant.title || '' : '';
              variantDisplay.hidden = !variantDisplay.textContent;
            }
            byId('iq-brand').textContent = vendor;
            byId('iq-brand').hidden = !vendor;
            byId('iq-reference-value').textContent = String(reference);
            byId('iq-reference-display').hidden = !reference;
            const image = variant.featured_image?.src || product.featured_image;
            if (image) {
              const imageURL = new URL(image, location.origin);
              if (['https:', 'http:'].includes(imageURL.protocol)) {
                if (imageURL.hostname === 'cdn.shopify.com' || imageURL.hostname.endsWith('.shopify.com')) { imageURL.searchParams.set('width', '640'); imageURL.searchParams.set('height', '640'); imageURL.searchParams.set('crop', 'center'); }
                byId('iq-img').src = imageURL.href;
                byId('iq-img').alt = '';
                byId('iq-img').closest('.kw-inquiry-media').hidden = false;
              }
            }
            const cents = Number(variant.price ?? product.price);
            const requestPrice = variant.available !== true || !Number.isFinite(cents) || cents <= 0 || tags.some(tag => ['price-on-request', 'price on request', 'por'].includes(tag.toLowerCase().trim()));
            const currency = window.Shopify?.currency?.active || 'USD';
            byId('iq-price').textContent = requestPrice ? strings.priceRequest : new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
            byId('iq-manual-watch').hidden = true;
            byId('iq-product-link').hidden = false;
            note.hidden = true;
            form.dataset.contextState = 'resolved';
            selectedContext = { handle, variantId: String(variant.id) };
            if (result === 'success') { try { sessionStorage.removeItem(contextKey); } catch {} }
          }).catch(showUnavailable).finally(() => { clearTimeout(timeout); submit.disabled = false; });
        } catch { showUnavailable(); }
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
